export const autoTextActionTypes = {
  AUTO_TEXT_FETCH_START: "AUTO_TEXT_FETCH_START",
  AUTO_TEXT_FETCH_SUCCESS: "AUTO_TEXT_FETCH_SUCCESS",
  AUTO_TEXT_FETCH_FAILURE: "AUTO_TEXT_FETCH_FAILURE",
  STANDARD_STATEMENTS_FETCH_START: "STANDARD_STATEMENTS_FETCH_START",
  STANDARD_STATEMENTS_FETCH_SUCCESS: "STANDARD_STATEMENTS_FETCH_SUCCESS",
  STANDARD_STATEMENTS_FETCH_FAILURE: "STANDARD_STATEMENTS_FETCH_FAILURE",
};
